export default __webpack_public_path__ + "static/B10-1c8b3cde1d0b3178936013eda39c44ee.png";